module.exports = __webpack_public_path__ + "img/new1.69336b1c.png";